<template>
    <div class="pager">
        <ul class="pager-section">
            <li class="pagination-item">
                <DxButton
                    template="perPage-1"
                    type="default"
                    styling-mode="contained"
                >
                    <template #perPage-1>
                        <span>5</span>
                    </template>
                </DxButton>
            </li>
            <li class="pagination-item">
                <DxButton
                    template="perPage-2"
                    type="default"
                    styling-mode="text"
                >
                    <template #perPage-2>
                        <span>10</span>
                    </template>
                </DxButton>
            </li>
        </ul>   
        <ul class="pager-section">
            <!--
            -- Se puede visualizar o no mediante la prop ":page-description" true/false
            -->
            <p 
                v-if="pagerDescription"
                class="pager-description"
            >
                Página {{currentPage}} de {{totalPages}} ({{totalReg}} items)
            </p>
            <li class="pagination-item">
                <DxButton
                    icon="chevrondoubleleft"
                    @click="onClickFirstPage"
                    :disabled="isInFirstPage"
                    type="default"
                    styling-mode="text"
                />
            </li>
            <li class="pagination-item">
                <DxButton
                    icon="chevronprev"
                    @click="onClickPreviousPage"
                    :disabled="isInFirstPage"
                    type="default"
                    styling-mode="text"
                />
            </li>
            <li v-for="(page, index) in pages" class="pagination-item" :key="index">
                <DxButton
                    template="btnContent"
                    @click="onClickPage(page.name)"
                    type="default"
                    :styling-mode="isPageActive(page.name) ? 'contained': 'text'"
                >
                    <template #btnContent>
                        <span>
                            {{page.name}}    
                        </span>
                    </template>
                </DxButton>
            </li>
            <li class="pagination-item">
                <DxButton
                    icon="chevronnext"
                    @click="onClickNextPage"
                    :disabled="isInLastPage"
                    type="default"
                    styling-mode="text"
                />
            </li>
            <li class="pagination-item">
                <DxButton
                    icon="chevrondoubleright"
                    @click="onClickLastPage"
                    :disabled="isInLastPage"
                    type="default"
                    styling-mode="text"
                />
            </li>
        </ul>
    </div>
</template>

<script>
    /**
     * Importaciones devExtreme
     */
    import DxButton from 'devextreme-vue/button';

    /**
     * Importaciones Vue
     */
    import { computed, ref } from 'vue';
    import { useStore } from 'vuex';

    export default {
        name: 'Pager',
        components: {
            DxButton
        },
        props: {
            maxVisibleButtons: {
            type: Number,
            required: false,
            default: 3
            },
            totalPages: {
            type: Number,
            required: true
            },
            currentPage: {
            type: Number,
            required: true
            },
            totalReg: {
                type: Number,
                required: true
            },
            pagerDescription: {
                type: Boolean,
                required: false,
                default:true
            }
        },
        setup(props, {emit}) {
            const range = ref([])
            const store = useStore();

            /**
             * COMPUTED PROPERTIES
             */
            const mobile = computed( () => store.state.mobile )

            const startPage = computed( () => {

                if(props.currentPage === 1) {
                    return 1;
                }
                if( props.currentPage === props.totalPages ) {
                    return mobile.value ? props.totalPages -1 : props.totalPages -2
                }
                return  mobile.value ? props.currentPage : props.currentPage -1;
            } );

            const endPage = computed( () => {
                if(props.currentPage === props.totalPages) {
                    return props.totalPages
                }    
                return Math.min(startPage.value + props.maxVisibleButtons -1, props.totalPages)
            } );

            const pages = computed( () => {
                    range.value=[];
                    for( let i = startPage.value; i <= endPage.value; i++ ) {
                        range.value.push({
                            name: i,
                            isDisabled: i === props.currentPage
                        });
                    }
                    return range.value;
            } );

            const isInFirstPage = computed( () => {
                return props.currentPage === 1;
            } );

            const isInLastPage = computed( () => {
                return props.currentPage === props.totalPages;
            } );

            /**
             * METHODS
             */
            const onClickFirstPage = () => {
                emit('pagechanged', 1);
            }
            const onClickPreviousPage = () => {
                emit('pagechanged', props.currentPage - 1);
            }
            const onClickPage = (page) => {
                emit('pagechanged', page);
            }
            const onClickNextPage = () => {
                emit('pagechanged', props.currentPage + 1);
            }
            const onClickLastPage = () => {
                emit('pagechanged', props.totalPages);    
            }
            const isPageActive = (page) => {
                return props.currentPage === page;
            }

            return { 
                startPage,
                endPage,
                pages,
                isInFirstPage,
                isInLastPage,
                onClickFirstPage,
                onClickPreviousPage,
                onClickPage,
                onClickNextPage,
                onClickLastPage,
                isPageActive,
                mobile 
            }
        }

    }
</script>

<style scoped>
    .pager {
        display: flex;
        justify-content: space-between;
    }

    .pager-section {
        list-style-type: none;
        margin-top: 10px;
        display: flex;
    }

    .pager-description {
        display: inline-flex;
        align-items: center;
        opacity: .6;
        font-weight: 500;

    }

    .pagination-item {
        min-height: 36px;
        display: inline-block;
    }

    .dx-button {
        margin-left: 5px;
        height: 100%;
        border-radius: 50%;
    }
</style>